/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-useless-escape */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/no-children-prop */
import {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useState,
  ElementType,
  useEffect
} from 'react'
import {
  FormControl,
  FormLabel,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormErrorMessage,
  InputGroup,
  InputRightElement,
  Icon,
  Stack,
  Box,
  Text,
  Flex
} from '@chakra-ui/react'
import { FieldError } from 'react-hook-form'

import { mask } from '../../utils/mask'
import { FlagCountries } from '../atoms/FlagCountries'

import CountriesDdi from '../../utils/json/countries.json'

interface Countries {
  sigla: string
  code: string
  name: string
}

interface InputProps extends ChakraInputProps {
  name: string
  label?: string
  error?: FieldError
  backCountries?: (country: Countries) => void
  type?: string
  isRequired?: boolean
  iconRight?: ElementType
  _active?: any
  disabled?: boolean
  size?: string
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  {
    name,
    label,
    error = null,
    type = 'text',
    isRequired = false,
    iconRight,
    disabled,
    size = 'md',
    backCountries,
    ...rest
  },
  ref
) => {
  const [value, setValue] = useState('')
  const [masker, setMasker] = useState('')
  const [DDI, setDDI] = useState('')

  // aplicar mascaras
  const changeValueApplyMask = useCallback(
    (e: any) => {
      const valueModifers = e.target.value

      if (masker === 'phoneBr') {
        setValue(mask(valueModifers, '99999999999'))
      } else {
        setValue(mask(valueModifers, '9999999999999999999'))
      }
    },
    [masker]
  )

  // mascara phone br
  function maskerPhone(mas: string) {
    if (mas === 'Brasil') {
      setMasker('phoneBr')
    } else {
      setMasker('')
    }
  }

  // capturando valor da flag
  const handleSelectedFlag = useCallback((e?: any) => {
    setValue('')
    CountriesDdi.map((country: Countries) => {
      if (country.name === e.name) {
        setDDI(country.code)
        maskerPhone(e.name)
        backCountries?.(country)
      }
    })
  }, [])

  useEffect(() => {
    setMasker('phoneBr')
    setDDI('+55')
  }, [])

  return (
    <Stack direction="row" w="100%" spacing="4" placeholder="">
      <Box w="25%" maxWidth="100px">
        <FlagCountries
          medium
          name="flag"
          title="País"
          selectedCountry={handleSelectedFlag}
        />
      </Box>
      <Box w="75%" flex="1">
        <FormControl
          isInvalid={!!error}
          isRequired={isRequired}
          bgColor="white"
        >
          {!!label && (
            <FormLabel fontSize="14px" htmlFor={name}>
              {label}
            </FormLabel>
          )}
          <InputGroup
            display="flex"
            onChange={(e: any) => changeValueApplyMask(e)}
          >
            <Flex w="100%" align="center">
              {!!DDI && (
                <Text w="50px" fontWeight="bold" color="blue.500" mr="2">
                  {DDI}
                </Text>
              )}
              <ChakraInput
                w="100%"
                borderRadius="none"
                name={name}
                id={name}
                focusBorderColor="blue.400"
                bgColor="white"
                borderColor="gray.100"
                borderWidth="1px"
                variant="filled"
                disabled={disabled}
                type={type}
                _hover={{
                  bgColor: 'blue.50'
                }}
                size={size}
                ref={ref}
                value={value}
                onChange={(e: any) => changeValueApplyMask(e.target.value)}
                {...rest}
              />
              {!!iconRight && (
                <InputRightElement
                  mt={size === 'md' ? '0px' : '4px'}
                  children={
                    <Icon
                      as={iconRight}
                      fontSize={size === 'md' ? '20px' : '24px'}
                      color="#9699B0"
                    />
                  }
                />
              )}
            </Flex>
          </InputGroup>
          {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
        </FormControl>
      </Box>
    </Stack>
  )
}

export const InputPhone = forwardRef(InputBase)
